import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on all pages



    // Offset heading posstion with button
    $('.section-heading').each(function () {
      const heading = $(this).find('.heading');
      const offset = $(this).find('.offset-width');

      let width;

      if (!offset.length) {
        width = 0;
      } else {
        width = offset.outerWidth();
      }

      heading.css('margin-left', width + 'px');
    });

    /**
     * Checks if element is in viewport
     * @param {*} elem
     */
    function isScrolledIntoView(elem) {

      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    /**
     * Formats the total value by adding commas
     * @param {*} total
     */
    function formatNumber(total) {
      let float = parseFloat(total, 10)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        .toString();
      return float.substring(0, float.length - 3);
    }

    // Animates stats
    if ($('[data-total]').length > 0) {
      $(window).on('scroll load', function () {
        $('span[data-total]').each(function () {
          if (isScrolledIntoView(this) === true) {

            let total = $(this).data('total');
            let comma = false;

            const pattern = /,/g;

            if (pattern.test(total)) {
              comma = true;
              total = $(this).data('total').replace(/,/g, '');
            }

            $(this)
              .prop('Counter', 0)
              .animate(
                {
                  Counter: total,
                },
                {
                  duration: 2500,
                  easing: 'swing',
                  step: function (now) {
                    if (comma) {
                      $(this).text(formatNumber(Math.ceil(now)));
                    } else {
                      $(this).text(Math.ceil(now));
                    }
                  },
                  complete: function () {
                    if (comma) {
                      $(this).text(formatNumber(total));
                    } else {
                      $(this).text(total);
                    }
                  },
                }
              );
          }
        });
      });
    }

    if ($('section.our-values').length > 0) {
      $('section.our-values ul li a').click(function (e) {
        e.preventDefault();
        $('.our-values ul li a').removeClass('active');
        $(this).addClass('active');

        let value = $(this).data('value');

        $('.our-values .bg-grey').each(function () {
          let content = $(this).data('content');

          if (value == content) {
            $(this).removeClass('d-none');
            $(this).addClass('d-block');
          } else {
            $(this).addClass('d-none');
            $(this).removeClass('d-block');
          }
        });
      });
    }

    if ($('.gallery').length > 0) {
      $(document).on('click', '.gallery .images a', function (e) {
        e.preventDefault();
        const img = $(this).attr('href');
        $.magnificPopup.open({
          items: {
            src: img,
          },
          type: 'image',
          midClick: true,
          mainClass: 'mfp-fade',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
          },
        });
      });
    }

    if( $('.blocks-gallery-grid a').length > 0) {
      $(document).on('click', '.blocks-gallery-grid a', function (e) {
        e.preventDefault();
        const img = $(this).attr('href');
        $.magnificPopup.open({
          items: {
            src: img,
          },
          type: 'image',
          midClick: true,
          mainClass: 'mfp-fade',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
          },
        });
      })
    }

    if ($('.event-videos').length > 0) {
      $(window).bind('load resize', function () {

        if ($(window).width() > 1199) {
          const mainVideoHeight = $('.event-videos .embed-responsive').height();
          $('.event-videos aside').css('height', mainVideoHeight + 'px');
        } else {
          $('.event-videos aside').css('height', 'auto');
        }
      });
    }

    if ($('.other-videos').length > 0) {
      $(document).on('click', '.other-videos a', function (e) {
        e.preventDefault();
        const video = $(this).attr('href');
        $.magnificPopup.open({
          items: {
            src: video,
          },
          type: 'iframe',
          midClick: true,
          mainClass: 'mfp-fade',
        });
      });
    }

    $(window).bind('load resize', function () {
      if ($(window).width() > 1199) {
        $('.nav-primary .menu-item-has-children').mouseover(function () {
          $(this)
            .find('.sub-menu')
            .stop()
            .slideDown();
        });

        $('.nav-primary .menu-item-has-children').mouseleave(function () {
          $(this)
            .find('.sub-menu')
            .stop()
            .slideUp();
        });
      }
    });

    $('.menu-item-has-children')
      .append('<button class="hamburger hamburger--minus" type="button"><span class="hamburger-box"><span class="hamburger-inner"></span></span></button>')

    $('button.hamburger').click(function () {
      $(this).toggleClass('is-active');
      if ($(this).hasClass('hamburger--squeeze')) {
        $('.nav-primary').slideToggle();
      } else {
        $(this).prev('.sub-menu').slideToggle();
      }
    });

    window.cookieconsent.initialise({
      palette: {
        popup: {
          background: '#e8e8e8',
        },
        button: {
          background: '#c12a23',
        },
      },
      position: 'bottom-left',
      content: {
        message: 'This website uses cookies to ensure you get the best experience on our website.',
        href: location.protocol + '//' + location.host + '/privacy-policy/',
        dismiss: 'Got it!',
      },
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Events slider
    if ($('.glide').length > 0) {

      const eventSliderInstance = document.getElementsByClassName('event-slider');
      Object.keys(eventSliderInstance).forEach(key => {
        new Glide(
          eventSliderInstance[key],
          {
            type: 'carousel',
            arrows: false,
            perView: 3,
            autoplay: 0,
            width: 100,
            breakpoints: {
              1410: {
                perView: 3,
              },
              1199: {
                perView: 2,
              },
              767: {
                perView: 1,
              },
            },
          }
        ).mount();
      });

      const advertSliderInstance = document.getElementsByClassName('footer-slider');
      Object.keys(advertSliderInstance).forEach(key => {
        new Glide(
          advertSliderInstance[key],
          {
            type: 'carousel',
            arrows: false,
            perView: 2,
            autoplay: 3000,
            focusAt: 'center',
            peek: {
              before: '50',
              after: '50',
            },
            breakpoints: {
              1410: {
                perView: 2,
              },
              1199: {
                perView: 2,
              },
              767: {
                perView: 1,
              },
            },
          }
        ).mount();
      });


      if($('.sponsor-slider').length > 0){

      new Glide('.sponsor-slider', {
        type: 'carousel',
        perView: 3,
        autoplay: 3000,
        hoverpause: true,
        arrows: true,
        breakpoints: {
          992: {
            perView: 2,
          },
          767: {
            perView: 1,
          },
        },
      }).mount();

    }

    const widgetSlideInstance = document.getElementsByClassName('sidebar-slider-widget');
    Object.keys(widgetSlideInstance).forEach(key => {
      new Glide(
        widgetSlideInstance[key],
        {
          type: 'carousel',
          perView: 1,
          autoplay: 3000,
          arrows: false,
        }
      ).mount();
    });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js